module.exports = __webpack_public_path__ + "img/circle-play-sharp-light.72f595ee.svg";